/* PDFCommunity - Flatten PDF (v147): form fields and comments become part of
   the page, so they can't be changed anymore and look the same everywhere.
   The work runs in the background worker (PC_JOBS.flattenPdf, pc-pdfcore.js,
   block TOOL FLATTEN): pure pdf-lib, no page or canvas needed, and Cancel stops
   it at once. Without a worker the same code runs on the page. */
(function(){
  'use strict';
  var MSG = {
    en: {
      working: 'Flattening…',
      infoOne: '1 file flattened (form fields: {0}, comments: {1})',
      infoMany: '{0} files flattened (form fields: {1}, comments: {2})',
      nothing: 'No form fields or comments to flatten in: {0}. The copy looks the same as the original.',
      hidden: 'Hidden form fields or comments were removed (they were not shown on screen or on paper): {0}.',
      screenOnly: 'Not flattened, because they only show on screen and are not printed (for example a Print button): {0}. They stay as they were.',
      noAp: 'These comments have no stored appearance, so they could not be flattened and stay as comments: {0}.',
      failed: 'These form fields contain characters the built-in font cannot show, so they stay fillable: {0}.',
      formError: 'The form of these files could not be read completely, so fields without a stored appearance stay fillable: {0}.',
      needOne: 'Choose what to flatten: form fields, comments or both.'
    },
    nl: {
      working: 'Bezig met afvlakken…',
      infoOne: '1 bestand afgevlakt (formuliervelden: {0}, opmerkingen: {1})',
      infoMany: '{0} bestanden afgevlakt (formuliervelden: {1}, opmerkingen: {2})',
      nothing: 'Geen formuliervelden of opmerkingen om af te vlakken in: {0}. De kopie ziet er hetzelfde uit als het origineel.',
      hidden: 'Verborgen formuliervelden of opmerkingen zijn verwijderd (ze waren niet zichtbaar op het scherm of op papier): {0}.',
      screenOnly: 'Niet afgevlakt omdat ze alleen op het scherm staan en niet afgedrukt worden (bv. een knop Afdrukken): {0}. Ze blijven zoals ze waren.',
      noAp: 'Deze opmerkingen hebben geen opgeslagen weergave. Ze konden niet afgevlakt worden en blijven opmerkingen: {0}.',
      failed: 'Deze formuliervelden bevatten tekens die het ingebouwde lettertype niet kan tonen. Ze blijven invulbaar: {0}.',
      formError: 'Het formulier van deze bestanden kon niet volledig gelezen worden. Velden zonder opgeslagen weergave blijven invulbaar: {0}.',
      needOne: 'Kies wat je wilt afvlakken: formuliervelden, opmerkingen of allebei.'
    },
    fr: {
      working: 'Aplatissement en cours…',
      infoOne: '1 fichier aplati (champs de formulaire : {0}, commentaires : {1})',
      infoMany: '{0} fichiers aplatis (champs de formulaire : {1}, commentaires : {2})',
      nothing: 'Aucun champ de formulaire ni commentaire à aplatir dans : {0}. La copie a le même aspect que l’original.',
      hidden: 'Les champs de formulaire ou commentaires masqués ont été supprimés (ils n’apparaissaient ni à l’écran ni sur papier) : {0}.',
      screenOnly: 'Non aplatis, car ils s’affichent seulement à l’écran et ne s’impriment pas (par ex. un bouton Imprimer) : {0}. Ils restent tels quels.',
      noAp: 'Ces commentaires n’ont pas d’apparence enregistrée, ils n’ont donc pas pu être aplatis et restent des commentaires : {0}.',
      failed: 'Ces champs de formulaire contiennent des caractères que la police intégrée ne peut pas afficher, ils restent donc modifiables : {0}.',
      formError: 'Le formulaire de ces fichiers n’a pas pu être lu entièrement, les champs sans apparence enregistrée restent donc modifiables\u00a0: {0}.',
      needOne: 'Choisissez ce qu’il faut aplatir : les champs de formulaire, les commentaires ou les deux.'
    },
    de: {
      working: 'Wird abgeflacht…',
      infoOne: '1 Datei abgeflacht (Formularfelder: {0}, Kommentare: {1})',
      infoMany: '{0} Dateien abgeflacht (Formularfelder: {1}, Kommentare: {2})',
      nothing: 'Keine Formularfelder oder Kommentare zum Abflachen in: {0}. Die Kopie sieht aus wie das Original.',
      hidden: 'Ausgeblendete Formularfelder oder Kommentare wurden entfernt (sie waren weder am Bildschirm noch auf Papier sichtbar): {0}.',
      screenOnly: 'Nicht abgeflacht, weil sie nur am Bildschirm erscheinen und nicht gedruckt werden (z. B. eine Schaltfläche „Drucken“): {0}. Sie bleiben, wie sie waren.',
      noAp: 'Diese Kommentare haben kein gespeichertes Erscheinungsbild. Sie konnten nicht abgeflacht werden und bleiben Kommentare: {0}.',
      failed: 'Diese Formularfelder enthalten Zeichen, die die eingebaute Schrift nicht darstellen kann. Sie bleiben ausfüllbar: {0}.',
      formError: 'Das Formular dieser Dateien ließ sich nicht vollständig lesen. Felder ohne gespeichertes Erscheinungsbild bleiben ausfüllbar: {0}.',
      needOne: 'Wählen Sie, was abgeflacht werden soll: Formularfelder, Kommentare oder beides.'
    },
    es: {
      working: 'Aplanando…',
      infoOne: '1 archivo aplanado (campos de formulario: {0}, comentarios: {1})',
      infoMany: '{0} archivos aplanados (campos de formulario: {1}, comentarios: {2})',
      nothing: 'No hay campos de formulario ni comentarios que aplanar en: {0}. La copia se ve igual que el original.',
      hidden: 'Se eliminaron campos de formulario o comentarios ocultos (no se veían ni en pantalla ni en papel): {0}.',
      screenOnly: 'No se aplanaron porque solo se ven en pantalla y no se imprimen (por ejemplo, un botón Imprimir): {0}. Se quedan como estaban.',
      noAp: 'Estos comentarios no tienen una apariencia guardada, así que no se pudieron aplanar y siguen siendo comentarios: {0}.',
      failed: 'Estos campos de formulario contienen caracteres que la fuente integrada no puede mostrar, así que siguen siendo editables: {0}.',
      formError: 'No se pudo leer por completo el formulario de estos archivos, así que los campos sin una apariencia guardada siguen siendo editables: {0}.',
      needOne: 'Elige qué aplanar: campos de formulario, comentarios o ambos.'
    },
    pt: {
      working: 'Achatando…',
      infoOne: '1 arquivo achatado (campos de formulário: {0}, comentários: {1})',
      infoMany: '{0} arquivos achatados (campos de formulário: {1}, comentários: {2})',
      nothing: 'Não há campos de formulário nem comentários para achatar em: {0}. A cópia fica igual ao original.',
      hidden: 'Campos de formulário ou comentários ocultos foram removidos (não apareciam na tela nem no papel): {0}.',
      screenOnly: 'Não foram achatados porque só aparecem na tela e não são impressos (por exemplo, um botão Imprimir): {0}. Eles continuam como estavam.',
      noAp: 'Estes comentários não têm uma aparência salva, por isso não puderam ser achatados e continuam como comentários: {0}.',
      failed: 'Estes campos de formulário contêm caracteres que a fonte embutida não consegue mostrar, por isso continuam editáveis: {0}.',
      formError: 'Não foi possível ler por completo o formulário destes arquivos, por isso os campos sem uma aparência salva continuam editáveis: {0}.',
      needOne: 'Escolha o que achatar: campos de formulário, comentários ou os dois.'
    },
    it: {
      working: 'Appiattimento in corso…',
      infoOne: '1 file appiattito (campi modulo: {0}, commenti: {1})',
      infoMany: '{0} file appiattiti (campi modulo: {1}, commenti: {2})',
      nothing: 'Nessun campo modulo o commento da appiattire in: {0}. La copia ha lo stesso aspetto dell’originale.',
      hidden: 'Sono stati rimossi campi modulo o commenti nascosti (non erano visibili né sullo schermo né su carta): {0}.',
      screenOnly: 'Non appiattiti perché compaiono solo sullo schermo e non vengono stampati (ad esempio un pulsante Stampa): {0}. Restano come erano.',
      noAp: 'Questi commenti non hanno un aspetto salvato, quindi non è stato possibile appiattirli e restano commenti: {0}.',
      failed: 'Questi campi modulo contengono caratteri che il font integrato non può mostrare, quindi restano compilabili: {0}.',
      formError: 'Non è stato possibile leggere del tutto il modulo di questi file, quindi i campi senza un aspetto salvato restano compilabili: {0}.',
      needOne: 'Scegli cosa appiattire: campi modulo, commenti o entrambi.'
    }, pl: {
      working: "Spłaszczanie…",
      infoOne: "Spłaszczono 1 plik (pola formularza: {0}, komentarze: {1})",
      infoMany: "Spłaszczono {0} {0#plik|pliki|plików} (pola formularza: {1}, komentarze: {2})",
      nothing: "Brak pól formularza i komentarzy do spłaszczenia w: {0}. Kopia wygląda tak samo jak oryginał.",
      hidden: "Usunięto ukryte pola formularza lub komentarze (nie były widoczne ani na ekranie, ani na papierze): {0}.",
      screenOnly: "Nie spłaszczono, bo są widoczne tylko na ekranie i nie są drukowane (np. przycisk Drukuj): {0}. Zostają bez zmian.",
      noAp: "Te komentarze nie mają zapisanego wyglądu, więc nie udało się ich spłaszczyć i pozostają komentarzami: {0}.",
      failed: "Te pola formularza zawierają znaki, których wbudowana czcionka nie potrafi wyświetlić, więc nadal można je wypełniać: {0}.",
      formError: "Nie udało się w pełni odczytać formularza w tych plikach, więc pola bez zapisanego wyglądu nadal można wypełniać: {0}.",
      needOne: "Wybierz, co spłaszczyć: pola formularza, komentarze lub jedno i drugie."
    }
  };
  var LANG = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2);
  var M = MSG[LANG] || MSG.en;
  function t(key){
    var s = M[key] != null ? M[key] : MSG.en[key];
    return pcFill.apply(null, [s].concat(Array.prototype.slice.call(arguments, 1)));
  }
  var $ = function(id){ return document.getElementById(id); };

  /* "a.pdf (2), b.pdf (1)" for the files where `key` counted something. */
  function countList(results, key){
    return results.filter(function(r){ return r[key] > 0; }).map(function(r){ return r.name + ' (' + r[key] + ')'; }).join(', ');
  }
  function sum(results, key){ return results.reduce(function(n, r){ return n + r[key]; }, 0); }
  function flattenNotes(results){
    var nothing = results.filter(function(r){ return !r.fields && !r.annots; }).map(function(r){ return r.name; }).join(', ');
    var failed = results.filter(function(r){ return r.failedFields.length; }).map(function(r){ return r.name + ': ' + r.failedFields.join(', '); }).join('; ');
    var formError = results.filter(function(r){ return r.formError; }).map(function(r){ return r.name; }).join(', ');
    var parts = [
      [nothing, 'nothing'], [countList(results, 'noAp'), 'noAp'], [failed, 'failed'], [formError, 'formError'],
      [countList(results, 'screenOnly'), 'screenOnly'], [countList(results, 'hidden'), 'hidden']
    ];
    // ownerNote, certBroke, xfaHybridNote: the same notes as Rotate/Delete (tools-extra.js)
    return toolNotes(results, parts.filter(function(p){ return p[0]; }).map(function(p){ return t(p[1], p[0]); }).join(' '));
  }

  pcOnPanel('flatten', function(){
    PCTools.setupTool('flatten', {
      accept: PCTools.isPdf, working: function(){ return t('working'); }, zipName: 'flattened-pdf', fieldId: 'flatten-fields',
      run: async function(files, _option, ctx){
        var opt = { fields: $('flatten-fields').checked, annots: $('flatten-annots').checked };
        if(!opt.fields && !opt.annots){
          throw Object.assign(new Error(t('needOne')), { userFacing: true, field: true });
        }
        var out = await PCTools.eachFile(files, ctx, function(file, i){
          return ctx.worker.run('flattenPdf', file, opt, function(frac){ ctx.setProgress((i + frac) / files.length); });
        });
        var r = out.results;
        out.info = r.length === 1 ? t('infoOne', r[0].fields, r[0].annots) : t('infoMany', r.length, sum(r, 'fields'), sum(r, 'annots'));
        out.note = flattenNotes(r);
        return out;
      }
    });
  });
})();
